<template>
  <LayoutLogin>
    <v-toolbar color="#450B0B" dark flat>
      <v-toolbar-title>Login</v-toolbar-title>
      <div class="flex-grow-1"></div>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field
          label="Login"
          name="login"
          prepend-icon="mdi-account-outline"
          type="text"
          v-model="usuario.login"
          autofocus
          @keyup.enter="login()"
        ></v-text-field>
        <v-text-field
          label="Senha"
          name="senha"
          prepend-icon="mdi-lock"
          type="password"
          v-model="usuario.senha"
          @keyup.enter="login()"
        ></v-text-field>
        <v-alert dense outlined type="error" v-for="(erro, index) of erros" :key="index">{{erro[0]}}</v-alert>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn color="#450B0B" class="white--text" @click="login()">Login</v-btn>
    </v-card-actions>
  </LayoutLogin>
</template>

<script>
import LayoutLogin from "@/components/layout/LayoutLogin";

export default {
  components: {
    LayoutLogin
  },
  data() {
    return {
      usuario: {
        login: "",
        senha: ""
      },
      erros: []
    };
  },
  methods: {
    login() {
      this.$http
        .post(this.$urlAPI + `/login`, {
          login: this.usuario.login,
          senha: this.usuario.senha
        })
        .then(response => {
          if (response.data.status) {
            this.$store.commit("setUsuario", response.data.usuario);
            sessionStorage.setItem(
              "usuario",
              JSON.stringify(response.data.usuario)
            );
            this.$store.commit("setPermissoes", response.data.permissoes);
            sessionStorage.setItem(
              "permissoes",
              JSON.stringify(response.data.permissoes)
            );
            this.$router.push("/#");
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          console.log(e);
          this.erros = null;
          this.erros = e;
        });
    }
  }
};
</script>
